module.exports = __webpack_public_path__ + "static/media/TrojanWarrior.c36b7230.jpg";